import { observable } from 'mobx';

export type HotelStayPlanResponseArgs = {
  id: string;
};

export type HotelStayPlanArgs = {
  id: string;
};

export const convertHotelStayPlanResponseToArgs = (response: HotelStayPlanResponseArgs) => {
  const args: HotelStayPlanArgs = {
    id: response.id
  };
  return args;
};

export default class HotelStayPlan {
  @observable id: string;

  constructor(args: HotelStayPlanArgs) {
    this.id = args.id;
  }
}
